import { ApiService } from "./api.service";
import { normalizeWorkHours } from "./work-hours.service";
import type {
  TAvailabilityConfig,
  TAvailabilityConfigUpdate,
  TMemberAvailability,
  TMyAvailabilityConfig,
} from "@/types/availability";

const normalizeAvailabilityConfig = <T extends TAvailabilityConfig>(config: T): T => ({
  ...config,
  work_hours: normalizeWorkHours(config.work_hours as unknown as Record<string, unknown>),
});

export class WorkspaceAvailabilityService extends ApiService {
  async getMyAvailabilityConfig(slug: string): Promise<TMyAvailabilityConfig> {
    const config = await this.get<TMyAvailabilityConfig>(
      `/api/workspaces/${slug}/availability-config/me/`,
    );
    return normalizeAvailabilityConfig(config);
  }

  async getMemberAvailabilityConfig(slug: string, userId: string): Promise<TAvailabilityConfig> {
    const config = await this.get<TAvailabilityConfig>(
      `/api/workspaces/${slug}/availability-config/${userId}/`,
    );
    return normalizeAvailabilityConfig(config);
  }

  async updateMemberAvailabilityConfig(
    slug: string,
    userId: string,
    payload: TAvailabilityConfigUpdate,
  ): Promise<TAvailabilityConfig> {
    const config = await this.patch<TAvailabilityConfig>(
      `/api/workspaces/${slug}/availability-config/${userId}/`,
      payload,
    );
    return normalizeAvailabilityConfig(config);
  }

  async getTeamAvailability(
    slug: string,
    startDate: string,
    endDate: string,
    memberIds?: string[],
  ): Promise<TMemberAvailability> {
    const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
    if (memberIds?.length) params.set("member_ids", memberIds.join(","));
    return this.get(`/api/workspaces/${slug}/team-availability/?${params.toString()}`);
  }
}
